/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import Notifications from "views/Notifications.js";
import Icons from "views/Icons.js";
import Typography from "views/Typography.js";
import TableList from "views/TableList.js";
import Maps from "views/Maps.js";
import Upgrade from "views/Upgrade.js";
import UserPage from "views/UserPage.js";
//import Principal from "views/Principal.js";
import Tendencias from "views/Tendencias.js";
import Historico from "./components/AnunciosHistorial";
import  Principal  from './components/AnunciosPrincipal'; 
import AnunciosComunicado from "./components/AnunciosComunicado";
import { AddAnuncios } from "./components/AddAnuncios";
import { AprobarAnuncio } from "./components/AprobarAnuncio";
import { Administrador } from './components/Administrador';
import { VerSuscripcion } from "./components/VerSuscripciones";


var dashRoutes = [
    {
        path: "/principal",
        name: "Principal",
        icon: "shopping_shop",
        component: Principal,
        layout: "/general",
    },
    //{
    //    path: "/tendencias",
    //    name: "Tendencias",
    //    icon: "design_app",
    //    component: Tendencias,
    //    layout: "/admin",
    //},
    {
        path: "/historico",
        name: "Historial",
        icon: "ui-2_time-alarm",
        component: Historico,
        layout: "/espoluser",
    },
    //{
    //    path: "/ver-suscripciones",
    //    name: "Mis Suscripciones",
    //    icon: "location_map-big",
    //    component: VerSuscripcion,
    //    layout: "/espoluser",
    //},
    {
        path: "/mis-comunicados",
        name: "Mis Comunicados",
        icon: "education_paper",
        component: AnunciosComunicado,
        layout: "/creator",
    },
    {
        path: "/add-anuncios",
        name: "Nuevo Comunicado",
        icon: "files_single-copy-04",
        component: AddAnuncios,
        layout: "/creator",
    },
    {
        path: "/aprobar-anuncio",
        name: "Aprobar",
        icon: "education_agenda-bookmark",
        component: AprobarAnuncio,
        layout: "/reviewer",
    },    
    {
        path: "/user-admin",
        name: "Administrador",
        icon: "business_badge",
        component: Administrador,
        layout: "/admin",
    },
];
export default dashRoutes;
